// Client-side mirror of the backend cost engine for instant live updates.
export const DEFAULT_MODEL = { pick_minutes_per_line: 1.5, repack_minutes_per_unit: 2.5 };

export function computeQuote(inputs, rates, model = DEFAULT_MODEL) {
  const n = (v) => (Number.isFinite(+v) ? +v : 0);
  const storage = n(inputs.storageSqft) * rates.storage * n(inputs.storageMonths);
  const inbound = n(inputs.inboundPallets) * rates.inbound;
  const pickLabor =
    n(inputs.monthlyOrders) * n(inputs.linesPerOrder) * (model.pick_minutes_per_line / 60) * rates.labor;
  const repackLabor = n(inputs.repackUnits) * (model.repack_minutes_per_unit / 60) * rates.labor;
  const handling = pickLabor + repackLabor;
  const outbound = n(inputs.outboundPallets) * rates.outbound;
  const subtotal = storage + inbound + handling + outbound;
  const ga = subtotal * (n(inputs.gaPercent) / 100);
  const total = subtotal + ga;
  return { storage, inbound, pickLabor, repackLabor, handling, outbound, subtotal, ga, total };
}

export const usd = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(
    Number.isFinite(+v) ? +v : 0
  );

export const num = (v) => new Intl.NumberFormat("en-US").format(Number.isFinite(+v) ? +v : 0);
